var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-ar",class:{ 'bg-transparent': _vm.loaded, 'bg-gray-100': !_vm.loaded },style:({
        'padding-bottom': 100 / (_vm.fillImgHeight ? _vm.srcRatio : _vm.ratio) + '%'
    })},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":function (e) {
                _vm.loaded = true;
                _vm.$emit('loaded');
                if (_vm.fillImgHeight) {
                    _vm.srcRatio =
                        e.currentTarget.naturalWidth /
                        e.currentTarget.naturalHeight;
                }
            },"~error":function($event){return (function (e) {
                e.currentTarget.src = _vm.srcError;
                _vm.$emit('loadError');
            })($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }